import styled from '@emotion/styled';

export const NextLogonMethodButton = styled.div`
	font-size: 14px;
	font-weight: 300;
	color: #0045db;
	margin-top: 16px;
	cursor: pointer;
`;
